import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { m } from 'framer-motion';
import { forwardRef } from 'react';
import * as views from './ContentWrapper.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var ContentWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: _jsx(views.Wrapper, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
export default ContentWrapper;